module.exports = __webpack_public_path__ + "img/schoolReport.e1a8bbc0.jpg";